import { s as e } from "../chunks/fields.D2__tAEU.js";
import { actionHandler as t } from "./lib/actionHandler.es.js";
import { TableIcon as n } from "lucide-react";
import { jsx as r } from "react/jsx-runtime";
//#region lib/TVListing/index.tsx
var i = (i) => ({
	class: "block",
	name: "tt/tv-listing",
	options: i,
	actions: [{
		name: "tt/tv-listing",
		title: "Tablåinfo",
		tool: () => /* @__PURE__ */ r(n, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: t,
		visibility: () => [
			!0,
			!0,
			!1
		]
	}],
	componentEntry: e()
});
//#endregion
export { i as TVListing };
